import React from 'react';
const ServicePlan = ({
  title,
  price,
  description,
  imageSrc,
  stripeLink
}: {
  title: string;
  price: string;
  description: string;
  imageSrc: string;
  stripeLink: string;
}) => {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:transform hover:-translate-y-1" data-id="element-51">
      <div className="h-168 overflow-hidden" data-id="element-52">
        <img src={imageSrc} alt={title} className="w-full h-full object-cover" data-id="element-53" />
      </div>
      <div className="p-6" data-id="element-54">
        <h3 className="text-xl font-bold mb-2 text-mwc-burgundy" data-id="element-55">{title}</h3>
        <p className="text-2xl font-bold text-mwc-green mb-4" data-id="element-56">{price}</p>
        <p className="text-gray-600 mb-6" data-id="element-57">{description}</p>
        <a href={stripeLink} className="block w-full bg-mwc-burgundy hover:bg-mwc-darkburgundy text-white font-semibold py-3 px-4 rounded-md transition-colors duration-300 text-center" data-id="element-58">
          Book Service Package
        </a>
      </div>
    </div>;
};
const ServicePlans = () => {
  const plans = [{
    title: 'Annual Maintenance Package',
    price: '12-Month Service – £99',
    description: 'Prepaid annual maintenance package for one household appliance. Includes 12 months of unlimited repair callouts, diagnostics, parts and labour, and priority engineer visits — ensuring your appliance receives professional maintenance and expert workmanship throughout the year.',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rx3NcGjdFyxpRgP7V2e5u5/Maplewood_staff_fixing_Dishwasher.jpg',
    stripeLink: 'https://buy.stripe.com/fZu14fduafbL8fJeMX3ks01'
  }, {
    title: 'TV & Set-Top Box Service Package',
    price: '12-Month Service Package – £120',
    description: 'Comprehensive annual service package for your TV and set-top box. This prepaid maintenance service includes unlimited repair visits, diagnostics, parts and labour, and rapid-response engineer callouts — keeping your entertainment system functioning reliably with professional technical support.',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i3r48ZKNYAoPu74gxfDsXC/Maplewood_staff_fixing_TV.jpg',
    stripeLink: 'https://buy.stripe.com/8x2dR1cq61kV8fJ6gr3ks02'
  }, {
    title: 'Extended Maintenance Package',
    price: 'Two-Year Service Package – £150.00',
    description: 'Extended prepaid maintenance service for one appliance over two years. This package includes unlimited repair callouts, diagnostics, parts and labour, and priority engineer visits from qualified technicians — delivering long-term reliability and professional workmanship for your household appliance.',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1KobkFQC2GgCjf9DAnw3FS/Maplewood_staff_fixing_Dishwasher_2.jpg',
    stripeLink: 'https://buy.stripe.com/dRm14ffCid3DcvZ34f3ks03'
  }];
  return <section className="py-16 bg-mwc-lightgray" data-id="element-59">
      <div className="container mx-auto px-4" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl font-bold text-mwc-burgundy mb-4" data-id="element-62">
            Prepaid Service Packages
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-63">
            Choose a prepaid maintenance package for convenient access to
            professional repairs, diagnostics, and priority engineer callouts.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-64">
          {plans.map((plan, index) => <ServicePlan key={index} title={plan.title} price={plan.price} description={plan.description} imageSrc={plan.imageSrc} stripeLink={plan.stripeLink} data-id="element-65" />)}
        </div>
      </div>
    </section>;
};
export default ServicePlans;